import React, {useState, useEffect} from "react";

import { OBJECT_EMPTY, GET_TOKEN } from "../../../helpers";
import { API_URL, POST_ADMIN_FILE_UPLOAD, POST_USER_FILES_RETURN_TABLE } from "../../../constants";

import { LoadingSpinner } from "../../../components/dashboard/partials/LoadingSpinner";
import { SmallSpinner } from "../../../components/dashboard/partials/SmallSpinner";
import { ReactTable } from "../../../components/Global/ReactTable/ReactTable";

import csvimg from '../../../images/CSV.png';
import csvfile from '../../../files/Sales_file_template.csv';
import anyimg from '../../../images/ANY.png';
import uploadimg from '../../../images/UPLOAD.jpg';


import "./UserFileImportTable.css";

export const UserFileImportTable = () => {
  const [dataLoaded, setDataLoaded] = useState(true);
  const [selectedTab, setSelectedTab] = useState(1);
  const [uploadSteps, setUploadSteps] = useState(2);
  const [fileToSubmit, setFileToSubmit] = useState([]);

  const [tableData, setTableData] = useState([]);
  const [parameters, setParameters] = useState([]);
  
  // Set Current table tab
  useEffect(() => {
    setUploadSteps(0)
    setFileToSubmit([])
  }, [selectedTab])

  useEffect(() => {
    fetch(API_URL + POST_USER_FILES_RETURN_TABLE, {
      method: "get",
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        setTableData([...response])
      })
  }, [])

  const submitFilesToUpload = () => {
    let allowCsvUpload = true

    // Check all files that currenlty being uploaded
    fileToSubmit.forEach(item => {
      return !(item.name?.toLowerCase().includes('.csv')) 
        && (allowCsvUpload = false)
    })

    // TODO move to if later
    const formData = new FormData();

    fileToSubmit.forEach((item, i) => {
      return formData.append(`file[${i}]`, item)
    })

    parameters.forEach((item, i) => {
      return formData.append(`id[${i}]`, item)
    })

    // formData.append('type', selectedTab)

    const request = new XMLHttpRequest();
          request.open('POST', API_URL + POST_ADMIN_FILE_UPLOAD + `?type=${selectedTab}`);
          request.setRequestHeader('Authorization', "Bearer " + GET_TOKEN())
          request.send(formData);
          
          request.onload = (e) => {
            request.status === 201 && setUploadSteps(2) 
          };

    // if (allowCsvUpload) {
    //   const formData = new FormData();

    //   fileToSubmit.forEach((item, i) => {
    //     return formData.append(`file[${i}]`, item)
    //   })

    //   parameters.forEach((item, i) => {
    //     return formData.append(`id[${i}]`, item)
    //   })
  
    //   const request = new XMLHttpRequest();
    //         request.open('POST', API_URL + POST_ADMIN_FILE_UPLOAD);
    //         request.setRequestHeader('Authorization', "Bearer " + GET_TOKEN())
    //         request.send(formData);
            
    //         request.onload = (e) => {
    //           request.status === 201 && setUploadSteps(2) 
    //         };

    // } else if (fileToSubmit.name?.toLowerCase().includes('.xlsx')) {
    //   console.log('.xlsx')
    // } else {
    //   console.log('wrong format')
    // }
  }

  const removeFromArray = (array, index) => {
    let arrayToUpdate = array;
    arrayToUpdate.splice(index, 1);

    return arrayToUpdate
  }

  const uploadTableConstructor = () => {
    const ReceivedFilesTableColumns = [
      {
        Header: "Country",
        accessor: "countryItem",
        Cell: (cell) => {
          return (
            <div className="countryCell">
              <img src={cell.data[cell.row.id].country.img} alt="flag" className="flag-icon-img"/>
              {cell.data[cell.row.id].country.name}
            </div>
          )
        },
      },
      {
        Header: "Return type",
        accessor: "return_type",
      },
      {
        Header: "Period",
        accessor: "period",
        className: "period"
      },
      {
        accessor: "select_all",
        className: "select_all",
        disableSortBy: true,

        Header: (header) => {
          let allChecked = header.data.length === parameters.length

          const checkAll = () => {
            let arrayOfAll = header.data.map((item) => item.id)

            return setParameters([...arrayOfAll])
          }

          const uncheckAll = () => {
            return setParameters([])
          }

          return (
            <label className="select_all_header">
              Select All
              <input 
                type="checkbox" 
                className="simple_checkbox"
                checked={allChecked}
                onChange={() => {
                  if (allChecked) uncheckAll()
                  else checkAll()
                }}
              />

            </label>
          )
        },

        Cell: (cell) => {
          return (
            
            <input 
              type="checkbox" 
              className="simple_checkbox"
              checked={parameters.indexOf(cell.data[cell.row.id].id) >= 0 ? true : false}
              onChange={() => {
                if (parameters.indexOf(cell.data[cell.row.id].id) >= 0) {
                  setParameters([...removeFromArray(parameters, parameters.indexOf(cell.data[cell.row.id].cell_id))])
                } else {
                  setParameters([...parameters, cell.data[cell.row.id].id ])
                }
              }}
            />
          )
        },
      },
    ];

    const ReceivedFilesList = () => {
      return <div className="userFileUploadTable__wrapper">
        <ReactTable className="userFileUploadTable" columns={ReceivedFilesTableColumns} data={tableData} />
      </div>
    }

    return dataLoaded 
      ? tableData.length > 0 ? ReceivedFilesList() : <h5>No VAT data</h5>
      : <LoadingSpinner/>
  }

  const SimpleFileUpload = () => {

    const stepOne = () => {
      return <>
        <ul className="fileToSubmit">
            {fileToSubmit.map((item, i) => {
              return <li className="fileToSubmit__item" key={item.name + i} >
                <button onClick={() =>  setFileToSubmit([...removeFromArray(fileToSubmit, i)])} />
                <p>{item.name}</p>
              </li>
            })}
        </ul>

        <button className="default_button" onClick={() => setUploadSteps(1)} > <div className="button-text">Proceed Upload <div className="icon_continue"></div></div> </button>

        <label className='uploadNewFile_upload_wrapper'>
          Upload more files
          
          <input
            type='file'
            name='file_upload'
            onChange={(e) => e.target.files !== null && setFileToSubmit([ ...fileToSubmit , ...e.target.files])}
            multiple
          />
        </label>
      </>
    }

    const stepTwo = () => {
      return (
        <>
          <div className="table_title">
            <button className="back_button icon" onClick={() => setUploadSteps(0)}></button>
            <h2>Select file related returns</h2>
          </div>
          {uploadTableConstructor()}

          <button className="default_button" onClick={() => {
            submitFilesToUpload()
          }}>
            <div className="button-text">Complete Upload<div className="icon_continue"></div></div>  
          </button>
        </>
      )
    }

    const stepThree = () => {
      return (
        <div className="stepThree">
          <div className="successImg"><img src={uploadimg} alt="upload"/></div>
          <h2>File upload complete</h2>
          <p className="description">You will be notified when your return declaration will be ready. Or you will be contacted by our manager if any aditional information will be needed</p>
          <button 
            className="default_button" 
            onClick={() => {
              setFileToSubmit([])
              setUploadSteps(0)
            }}> 
              <div className="button-text">Upload more? <div className="icon_upload"></div> </div> 
            </button>

        </div>
      )
    }

    const costructorSimpleFileUpload = () => {
      if (fileToSubmit.length <= 0) {
        return <>
          <label className='uploadNewFile_upload_wrapper default_button'>
            {/* <p>Upload Files <img src={uploadimg} alt="upload icon"/> </p> */}
            <div className="button-text">Upload Files <div className="icon_upload"></div> </div>
            
            <input
              type='file'
              name='file_upload'
              onChange={(e) => e.target.files !== null && setFileToSubmit([...e.target.files])}
              multiple
            />
          </label>
      </>
      } else {
        if (uploadSteps === 0) {
          return stepOne()
        } else if ( uploadSteps === 1 ) {
          return stepTwo()
        } else if ( uploadSteps === 2 ) {
           return stepThree()
        }
      }
    }

    return <div className="SimpleFileUpload border">
      {costructorSimpleFileUpload()}
    </div>
  }
  
  return (
    <div className="UserFileImportTable">

      <div className="UserFileImportTable__top flex">
        <ul className="UserFileImportTable__tabs">
          <li> 
            <button onClick={() => setSelectedTab(1)} className={ selectedTab === 1 ? 'active' : '' }>
              <div className="UserFileImportTable__tabs__item">
                <div className="icon">
                  <img src={csvimg} alt="csvimg"/>
                </div>
                
                <div className="content">
                  <h5>1stopvat file format CSV</h5>
                  <p>(Reccomended)</p>
                </div>
              </div>
            </button>
          </li>

          <li>
            <button onClick={() => setSelectedTab(2)} className={ selectedTab === 2 ? 'active' : '' }>
              <div className="UserFileImportTable__tabs__item">
                <div className="icon">
                  <img src={anyimg} alt="anyimg"/>
                </div>
                
                <div className="content">
                  <h5>Any custom file format</h5>
                  <p>(Additial fee will be applied)</p>
                </div>
              </div>
            </button>
          </li>
        </ul>

        {selectedTab === 1 && (
          <a 
            className="flex "
            href={csvfile}
            download
          >
            <div className="icon download--violet"></div>
            Download file template
          </a>
        )}
      </div>



      <SimpleFileUpload />
    </div>
  );
};
